import { render } from "./DeclareModel.vue?vue&type=template&id=dfd75780&scoped=true"
import script from "./DeclareModel.vue?vue&type=script&lang=js"
export * from "./DeclareModel.vue?vue&type=script&lang=js"

import "./DeclareModel.vue?vue&type=style&index=0&id=dfd75780&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd75780"]])

export default __exports__